import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

// Components
import GlitchIntro from './components/GlitchIntro'
import About from './components/About'
import Projects from './components/ProjectsNew'
import Skills from './components/Skills'
import Contact from './components/Contact'
import Navigation from './components/Navigation'
import LoadingScreen from './components/LoadingScreen'

function App() {
  return (
    <Router>
      <div className="relative min-h-screen bg-black text-white overflow-x-hidden">

        {/* Navigation */}
        <Navigation />

        {/* Main Content */}
        <main className="relative z-10">
          <Routes>
            <Route path="/" element={
              <>
                <GlitchIntro />
                <About />
                <Skills />
                <Projects />
                <Contact />
              </>
            } />
          </Routes>
        </main>

        {/* Loading Screen */}
        <LoadingScreen />
      </div>
    </Router>
  )
}

export default App
